import theme from '@styles/theme';
export default {
  productDescriptionContainer: {
    paddingLeft: ['16px', '16px', '20px', '20px', '56px', '56px'],
    paddingRight: ['unset', 'unset', '16px'],
    flex: ['auto', 1],
    display: 'flex',
    flexDirection: 'column',
    whiteSpace: 'break-spaces'
  },
  productNameLink: {
    height: 'auto'
  },
  productName: {
    color: theme.rawColors.darkGrey700
  },
  productNameType: {
    color: theme.rawColors.darkGrey600,
    paddingBottom: '24px'
  },
  productSize: {
    color: theme.rawColors.darkGrey600
  },
  productDescription: {
    color: theme.rawColors.darkGrey600,
    fontSize: theme.fontSizes.caption,
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    alignItems: 'start',
    flexGrow: 1,
    display: 'flex',
    whiteSpace: 'break-spaces'
  }
};